import styled from 'styled-components';
var cardOverlayHeight = 35;
var CardOverlay = styled.div.withConfig({
  displayName: "CardOverlay",
  componentId: "y73crc-0"
})(["position:absolute;height:", "px;right:0;bottom:0;left:0;opacity:0;text-align:center;transition:opacity 0.4s ease-out;.btn.btn-link{font-size:16px;padding:0 6px 0 6px;}"], cardOverlayHeight);
export default CardOverlay;